import { storableError } from '../../util/errors';
import { parse } from '../../util/urlHelpers';
import { fetchPostList } from './wpApi';

const POSTS_PER_PAGE = 20;

// ─── Action types ───────────────────────────────────────────────────────────
export const POSTS_REQUEST = 'app/BlogIndexPage/POSTS_REQUEST';
export const POSTS_SUCCESS = 'app/BlogIndexPage/POSTS_SUCCESS';
export const POSTS_ERROR = 'app/BlogIndexPage/POSTS_ERROR';

// ─── Reducer ────────────────────────────────────────────────────────────────
const initialState = {
  posts: [],
  total: 0,
  totalPages: 0,
  page: 1,
  loadInProgress: false,
  loadError: null,
};

const reducer = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case POSTS_REQUEST:
      return { ...state, loadInProgress: true, loadError: null };
    case POSTS_SUCCESS:
      return {
        ...state,
        loadInProgress: false,
        posts: payload.posts,
        total: payload.total || 0,
        totalPages: payload.totalPages || 0,
        page: payload.page || 1,
      };
    case POSTS_ERROR:
      return { ...state, loadInProgress: false, loadError: payload };
    default:
      return state;
  }
};

export default reducer;

// ─── Action creators ────────────────────────────────────────────────────────
const postsRequest = () => ({ type: POSTS_REQUEST });
const postsSuccess = (payload) => ({ type: POSTS_SUCCESS, payload });
const postsError = (e) => ({ type: POSTS_ERROR, error: true, payload: e });

// ─── loadData (SSR entry point) ─────────────────────────────────────────────
export const loadData = (params, search) => (dispatch) => {
  const { page: pageQuery } = parse(search) || {};
  const page = parseInt(pageQuery, 10) > 0 ? parseInt(pageQuery, 10) : 1;

  dispatch(postsRequest());

  return fetchPostList({ page, perPage: POSTS_PER_PAGE })
    .then((res) => {
      dispatch(postsSuccess(res));
      return res;
    })
    .catch((e) => {
      const error = storableError(e);
      dispatch(postsError(error));
      // Don't rethrow — render an error state rather than failing the SSR.
    });
};
